'use client';
import { setToString } from './set.utils.js';
import { iterToSet } from './transform.utils.js';
import { ROOT_CLASSNAMES } from '../constants/globals.js';

function getRootClassNames({ standardMode = false, darkMode = false, compactMode = false } = {}, defaultClassNames = []) {
    const classNameSet = iterToSet(defaultClassNames);
    classNameSet.add(ROOT_CLASSNAMES.base);
    if (standardMode) {
        classNameSet.add(ROOT_CLASSNAMES.standardMode);
    }
    if (darkMode) {
        classNameSet.add(ROOT_CLASSNAMES.darkMode);
    }
    if (compactMode) {
        classNameSet.add(ROOT_CLASSNAMES.compactMode);
    }
    return setToString(classNameSet);
}

export { getRootClassNames };
